const hydrateStore = (state) => ({
  type: 'HYDRATE_STORE',
  state,
});

export {
  hydrateStore,
}
